import React from 'react'
import { Redirect } from 'react-router-dom'

const OrganizationHome = () => <Redirect to='/organization/entities' />

export default OrganizationHome
